import { SlicePipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import {
  LANDMARKS_CATEGORY_LANDMARK,
  LANDMARKS_VALIDATE,
} from '../../../component/management-tab/landmarks-sub-tab/landmarks-routing.constants';
import LandmarksService from '../../../services/landmarks.service';
import { PermissionService } from '../../../services/permission.service';
import { LandmarkCardComponent } from '../../shared/card/landmark-card/landmark-card.component';
import { WidgetLoaderComponent } from '../../shared/widget/widget-loader/widget-loader.component';

@Component({
  selector: 'widget-validate-poi',
  templateUrl: './widget-validate-poi.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LandmarkCardComponent,
    TranslatePipe,
    MatIcon,
    MatTooltipModule,
    WidgetLoaderComponent,
    RouterLink,
    SlicePipe,
  ],
})
export class WidgetValidatePoiComponent {
  public permissionService = inject(PermissionService);
  private _landmarksService = inject(LandmarksService);
  private _router = inject(Router);
  public $landmarks = this._landmarksService.$toValidate;
  public readonly LANDMARKS_VALIDATE = LANDMARKS_VALIDATE;

  public navigateToLandmark(uid: number, uid_category: number) {
    this._router.navigate([LANDMARKS_CATEGORY_LANDMARK(uid_category, uid)], { queryParams: { view: 'map' } });
  }
}
